<!-- Fuera del inicio el header va corto: solo la barra, sin banner ni tarjetas -->
<header class="home-header" [class.home-header-dark]="currentSkin === 'dark'"
        [class.home-header-compact]="!isHome" [ngStyle]="headerBgStyle">

  <!-- Reserva el alto de la barra cuando queda fija, así el contenido no salta -->
  <div class="hh-top-spacer" *ngIf="topBarFixed" [style.height.px]="topBarSpacer"></div>

  <!-- Top bar: logo + nav pill + actions -->
  <div #topBar class="home-header-top" [class.hh-top-fixed]="topBarFixed || hoverRevealed"
       [class.hh-hover-revealed]="hoverRevealed">

    <!-- Logo B.R.A.I.N. -->
    <a [routerLink]="['/']" class="brain-logo">
      <span class="brain-logo-icon">
        <img src="assets/images/logo/brain_logo.png" alt="B.R.A.I.N." />
      </span>
      <span class="brain-logo-label">
        <span class="brain-logo-text">B.R.A.I.N.</span>
        <span class="brain-logo-by">by Beliv</span>
        <!-- Badges de entorno -->
        @if(environment.dev || environment.qa){
          <span class="bl-env-badges">
            <span class="badge badge-pill badge-glow badge-danger" *ngIf="environment.dev">Dev</span>
            <span class="badge badge-pill badge-glow badge-danger" *ngIf="environment.qa">Beta</span>
          </span>
        }
      </span>
    </a>

    <!-- Mobile hamburger -->
    <button class="btn-icon d-lg-none hh-hamburger" (click)="toggleMobileMenu()" aria-label="Menu">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    </button>

    <!-- Nav pill: links centrados + search + user actions -->
    <nav class="hh-fixed-nav d-none d-lg-flex" [class.hh-nav-collapsed]="!navbarPinned && navHidden && !hoverRevealed">

      <!-- Links centrados -->
      <div class="hh-nav-links">
        <a *ngFor="let item of navItems"
           [routerLink]="'/' + item.url"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: item.url === 'pages/home'}"
           class="hh-nav-link">
          {{ getNavLabel(item) }}
        </a>
      </div>

      <!-- Separador — empuja acciones a la derecha -->
      <span class="hh-nav-divider"></span>

      <!-- Search -->
      <form class="hh-search" (submit)="onSearchSubmit($event)">
        <svg class="hh-search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input type="text" [(ngModel)]="searchTerm" name="homeSearch"
               placeholder="{{ 'COMMON.SEARCH' | translate }}" aria-label="search" />
      </form>

      <!-- Favorites (heart) -->
      <button class="btn-icon hh-icon" [class.is-favorite]="isCurrentFavorite"
              [disabled]="favoriteLoading" (click)="onFavorite()" aria-label="Favorites">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
          [attr.fill]="isCurrentFavorite ? '#e53935' : 'none'"
          [attr.stroke]="isCurrentFavorite ? '#e53935' : 'currentColor'"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      </button>

      <!-- Bryant: abre el panel acoplado, ya no navega a otra página -->
      <button *ngIf="canSeeBIX" type="button" class="btn-icon hh-icon hh-bix"
         [class.is-active]="bryantOpen" (click)="toggleBryant()"
         ngbPopover="{{'BELIVPEDIA.MESSAGES.VIEW_BIX' | translate}}"
         #popoverBix="ngbPopover" container="body" triggers="manual" closeDelay="60000">
        <img src="https://belivthumbs.blob.core.windows.net/prod/bot.ico" alt="Bryant" height="26" width="26" class="hh-bix-avatar" />
      </button>

      <!-- User -->
      <div ngbDropdown container="body" placement="bottom-right" class="hh-action" *ngIf="currentUser">
        <button ngbDropdownToggle class="btn-icon hh-user-btn" id="hhUserDropdown">
          <span class="hh-avatar-wrapper">
            <img *ngIf="profilePhoto && profilePhoto.length > 0"
                 class="hh-avatar-img" [src]="profilePhoto" alt="avatar" height="36" width="36" />
            <span *ngIf="!profilePhoto || profilePhoto.length === 0" class="hh-avatar-initials">
              {{ currentUser.person.name | slice:0:1 }}{{ currentUser.person.surname | slice:0:1 }}
            </span>
            <span class="hh-status-online"></span>
          </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="hhUserDropdown" class="dropdown-menu-right hh-glass-menu">
          <div class="dropdown-header px-3 py-2">
            <div class="hh-user-fullname">{{ currentUser.person.name }} {{ currentUser.person.surname }}</div>
          </div>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem (click)="logout()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="mr-50">
              <path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/>
            </svg>
            {{ 'COMMON.BUTTONS.LOG_OUT' | translate }}
          </button>
        </div>
      </div>

    </nav>

    <!-- Acciones fuera del pill: company, language, dark mode, pin -->
    <div class="hh-actions d-none d-lg-flex">

      <!-- Company (solo si el usuario tiene acceso a más de una empresa) -->
      <div ngbDropdown container="body" placement="bottom-right" class="hh-action" *ngIf="showCompanySelector">
        <button ngbDropdownToggle class="btn-icon hh-icon hh-company-btn" id="hhCompanyDropdown" aria-label="Empresa">
          <span class="hh-company-name">{{ selectedCompany?.name }}</span>
        </button>
          <div
                  ngbDropdownMenu
                  aria-labelledby="hhCompanyDropdown"
                  class="hh-glass-menu hh-company-menu">

              <button
                      *ngFor="let company of companies"
                      ngbDropdownItem
                      [class.active]="company.id === selectedCompany?.id"
                      (click)="changeCompany(company)">

                  {{ company.name }}

              </button>

          </div>
      </div>

      <!-- Language -->
      <div ngbDropdown container="body" placement="bottom-right" class="hh-action" *ngIf="selectedLanguage">
        <button ngbDropdownToggle class="btn-icon hh-icon" id="hhLangDropdown" aria-label="Language">
          <i class="flag-icon flag-icon-{{ languageOptions[selectedLanguage]?.flag }}"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="hhLangDropdown" class="hh-glass-menu">
          <button *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
            <i class="flag-icon flag-icon-{{ languageOptions[lang]?.flag }}"></i> {{ languageOptions[lang]?.title }}
          </button>
        </div>
      </div>

      <!-- Dark mode toggle -->
      <button class="btn-icon hh-icon" (click)="toggleDarkSkin()" aria-label="Toggle theme">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="feather"></span>
      </button>

      <!-- Switch de versión del layout (solo administradores): recarga con la otra -->
      <button type="button" class="btn-icon hh-icon" *ngIf="layoutSwitch.canSwitch(currentUser)"
              (click)="layoutSwitch.switchLayout()"
              [attr.title]="'COMMON.ACTIONS.SWITCH_LAYOUT' | translate:{ version: layoutSwitch.targetVersion }"
              [attr.aria-label]="'COMMON.ACTIONS.SWITCH_LAYOUT' | translate:{ version: layoutSwitch.targetVersion }">
        <lucide-icon name="layout-template" [size]="20"></lucide-icon>
      </button>

      <!-- Pin / Unpin -->
      <button class="btn-icon hh-icon" (click)="onPinToggle()"
              [title]="navbarPinned ? 'Auto-ocultar al scroll' : 'Fijar navbar'">
        <svg *ngIf="navbarPinned" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        <svg *ngIf="!navbarPinned" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/>
        </svg>
      </button>

      <ng-container *ngIf="uploadManagerService.status$ | async as upload">
        <button *ngIf="upload.active" type="button" class="btn-icon hh-icon hh-upload-fab"
                (click)="uploadManagerService.togglePanel()"
                [attr.title]="'COMMON.MESSAGES.UPLOAD_PROGRESS' | translate"
                [attr.aria-label]="'COMMON.MESSAGES.UPLOAD_PROGRESS' | translate">
          <svg class="hh-upload-fab__ring" viewBox="0 0 36 36" aria-hidden="true">
            <circle class="hh-upload-fab__track" cx="18" cy="18" r="16"></circle>
            <circle class="hh-upload-fab__value" cx="18" cy="18" r="16" pathLength="100" [attr.stroke-dasharray]="upload.progress + ' 100'"></circle>
          </svg>
          <lucide-icon name="arrow-up-to-line" [size]="18" class="hh-upload-fab__icon"></lucide-icon>
        </button>
      </ng-container>

    </div>
  </div>


  <!-- Welcome banner + stats cards: solo en el inicio -->
  <div class="home-header-banner" *ngIf="isHome">
    <div class="hh-welcome">
      <div class="hh-welcome-small">{{ 'COMMON.MESSAGES.WELCOME_TO' | translate }}</div>
      <div class="hh-welcome-big" [innerHTML]="bannerTitleKey | translate"></div>
    </div>

    <!-- Frase aleatoria de bienvenida: centrada en la pantalla. Recibe el nombre
         del usuario ({{user}}) y va por innerHTML porque el texto trae <b>.
         Si la key todavía no existe en las traducciones no se muestra nada. -->
    <div class="hh-welcome-phrase" *ngIf="welcomePhraseKey">
      <span *ngIf="(welcomePhraseKey | translate) !== welcomePhraseKey"
            [innerHTML]="welcomePhraseKey | translate:{ user: userFirstName }"></span>
    </div>

    <div class="hh-stats">
      <div class="hh-stat-card hh-stat-card--big">
        <span class="hh-stat-number">{{ headquartersCount ?? '...' }}</span>
        <span class="hh-stat-label">{{ 'HEADQUARTERS.MAP.TITLE' | translate }}</span>
      </div>
      <div class="hh-stat-card hh-stat-card--big">
        <span class="hh-stat-number">{{ dashboardsCount ?? '...' }}</span>
        <span class="hh-stat-label">{{ 'PAGES.HOME.DASHBOARDS' | translate }}</span>
      </div>

      <!-- Acceso a la comunidad de IA en Viva Engage, incrustada dentro de la app
           (embedded/site/ai-community, ver FIXED_EMBEDDED_SITES) -->
      <a class="hh-stat-card hh-stat-card--big hh-stat-card--link"
         [routerLink]="['/embedded/site/ai-community']"
         (click)="openAiCommunity()"
         [attr.title]="'PAGES.HOME.AI_COMMUNITY_HINT' | translate"
         [attr.aria-label]="'PAGES.HOME.AI_COMMUNITY_HINT' | translate">
        <lucide-icon name="sparkles" [size]="34" class="hh-stat-lucide"></lucide-icon>
        <span class="hh-stat-label">{{ 'PAGES.HOME.AI_COMMUNITY' | translate }}</span>
      </a>
    </div>
  </div>

</header>

<!-- Mobile drawer -->
<div class="hh-mobile-backdrop" *ngIf="mobileMenuOpen" (click)="closeMobileMenu()"></div>

<aside class="hh-mobile-drawer d-lg-none" [class.open]="mobileMenuOpen">
  <div class="hh-mobile-head">
    <a [routerLink]="['/']" class="brain-logo hh-mobile-logo" (click)="closeMobileMenu()">
      <span class="brain-logo-icon">
        <img src="assets/images/logo/brain_logo.png" alt="B.R.A.I.N." />
      </span>
      <span class="brain-logo-label">
        <span class="brain-logo-text">B.R.A.I.N.</span>
        <span class="brain-logo-by">by Beliv</span>
        <!-- Badges de entorno -->
        @if(environment.dev || environment.qa){
          <span class="bl-env-badges">
            <span class="badge badge-pill badge-glow badge-danger" *ngIf="environment.dev">Dev</span>
            <span class="badge badge-pill badge-glow badge-danger" *ngIf="environment.qa">Beta</span>
          </span>
        }
      </span>
    </a>
    <button class="btn-icon hh-mobile-close" (click)="closeMobileMenu()" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- Búsqueda mobile -->
  <div class="hh-mobile-search">
    <form (submit)="onSearchSubmit($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input type="text" [(ngModel)]="searchTerm" name="mobileSearch"
             placeholder="{{ 'COMMON.SEARCH' | translate }}" aria-label="search" />
    </form>
  </div>

  <nav class="hh-mobile-nav">
    <a *ngFor="let item of navItems"
       class="hh-mobile-item"
       [routerLink]="'/' + item.url"
       routerLinkActive="active"
       [routerLinkActiveOptions]="{ exact: item.url === 'pages/home' }"
       (click)="onLeafClick()">
      <!-- El icono puede ser un nombre de lucide, una clase de fuente o una imagen subida -->
      <app-lucide-icon class="menu-icon-lucide" [name]="lucideIconName(item.icon)" [size]="18"
                       *ngIf="isLucideIcon(item.icon)"></app-lucide-icon>
      <img *ngIf="!isLucideIcon(item.icon) && isImageIcon(item.icon)" class="menu-icon-img" [src]="item.icon" alt="" />
      <i *ngIf="!isLucideIcon(item.icon) && !isImageIcon(item.icon)" [ngClass]="item.icon || 'fa fa-circle'"></i>
      <span>{{ getNavLabel(item) }}</span>
    </a>
  </nav>

  <!-- Footer del drawer: empresa + user info + acciones -->
  <div class="hh-mobile-footer">

    <!-- Company (solo si el usuario tiene acceso a más de una empresa) -->
    <div ngbDropdown placement="top" class="hh-mobile-company" *ngIf="showCompanySelector">
      <button ngbDropdownToggle class="hh-mobile-company-btn" id="hhMobileCompanyDropdown">
        <span class="hh-mobile-company-name">{{ selectedCompany?.name }}</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="hhMobileCompanyDropdown" class="hh-glass-menu">
        <button *ngFor="let company of companies" ngbDropdownItem
          [class.active]="company.id === selectedCompany?.id" (click)="changeCompany(company)">
          {{ company.name }}
        </button>
      </div>
    </div>

    <!-- User info -->
    <div class="hh-mobile-user" *ngIf="currentUser">
      <span class="hh-avatar-wrapper hh-mobile-avatar">
        <img *ngIf="profilePhoto && profilePhoto.length > 0"
             class="hh-avatar-img" [src]="profilePhoto" alt="avatar" height="34" width="34" />
        <span *ngIf="!profilePhoto || profilePhoto.length === 0" class="hh-avatar-initials">
          {{ currentUser.person.name | slice:0:1 }}{{ currentUser.person.surname | slice:0:1 }}
        </span>
      </span>
      <span class="hh-mobile-username">{{ currentUser.person.name }} {{ currentUser.person.surname }}</span>
    </div>

    <!-- Acciones: favoritos, BIX, idioma, modo dark -->
    <div class="hh-mobile-actions-row">

      <button class="btn-icon hh-mobile-action-btn" [class.is-favorite]="isCurrentFavorite"
              [disabled]="favoriteLoading" (click)="onFavorite()" aria-label="Favorites">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          [attr.fill]="isCurrentFavorite ? '#e53935' : 'none'"
          [attr.stroke]="isCurrentFavorite ? '#e53935' : 'currentColor'"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      </button>

      <button *ngIf="canSeeBIX" type="button" class="btn-icon hh-mobile-action-btn"
              (click)="closeMobileMenu(); toggleBryant()" aria-label="Bryant">
        <img src="https://belivthumbs.blob.core.windows.net/prod/bot.ico" alt="Bryant" height="24" width="24" style="border-radius:50%" />
      </button>

      <div ngbDropdown placement="top-left" *ngIf="selectedLanguage">
        <button ngbDropdownToggle class="btn-icon hh-mobile-action-btn" aria-label="Language">
          <i class="flag-icon flag-icon-{{ languageOptions[selectedLanguage]?.flag }}"></i>
        </button>
        <div ngbDropdownMenu class="hh-glass-menu">
          <button *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
            <i class="flag-icon flag-icon-{{ languageOptions[lang]?.flag }}"></i> {{ languageOptions[lang]?.title }}
          </button>
        </div>
      </div>

      <button class="btn-icon hh-mobile-action-btn" (click)="toggleDarkSkin()" aria-label="Toggle theme">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="feather"></span>
      </button>

      <button type="button" class="btn-icon hh-mobile-action-btn" *ngIf="layoutSwitch.canSwitch(currentUser)"
              (click)="layoutSwitch.switchLayout()"
              [attr.title]="'COMMON.ACTIONS.SWITCH_LAYOUT' | translate:{ version: layoutSwitch.targetVersion }"
              [attr.aria-label]="'COMMON.ACTIONS.SWITCH_LAYOUT' | translate:{ version: layoutSwitch.targetVersion }">
        <lucide-icon name="layout-template" [size]="20"></lucide-icon>
      </button>

      <button class="btn-icon hh-mobile-action-btn" (click)="onPinToggle()"
              [title]="navbarPinned ? 'Auto-ocultar al scroll' : 'Fijar navbar'">
        <svg *ngIf="navbarPinned" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        <svg *ngIf="!navbarPinned" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/>
        </svg>
      </button>

    </div>

    <!-- Logout -->
    <button class="hh-mobile-logout" (click)="logout()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
        <polyline points="16 17 21 12 16 7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
      </svg>
      {{ 'COMMON.BUTTONS.LOG_OUT' | translate }}
    </button>

  </div>
</aside>
